import React from "react";
import { FaWhatsapp } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import HeroSection from "../../components/common/HeroSection";
import PageShell from "../../components/common/PageShell";
import SectionHeader from "../../components/common/SectionHeader";
import ScrollReveal from "../../components/common/Reveal";
import ContactForm from "../../components/contact/ContactForm";
import ContactMap from "../../components/contact/ContactMap";
import { PAGE_HEROES } from "../../constants/pageHeroes";
import { SITE } from "../../constants/site";
import { SECTION_CONTAINER } from "../../utils/layout";
import "./Contact.css";

function Contact() {
  const { t } = useTranslation();
  const whatsappHref = `https://wa.me/${SITE.whatsappNumber.replace(/\D/g, "")}`;

  return (
    <PageShell>
      <HeroSection {...PAGE_HEROES.contact} variant="page" />
      <section className="contact-page caf-section caf-section--elevated" data-reveal-managed="">
        <div className={`${SECTION_CONTAINER} contact-page__inner`}>
          <ScrollReveal className="contact-page__intro">
            <SectionHeader
              eyebrow={t("Reach Us")}
              title={t("Contact Us")}
              subtitle={t("contact.pageSubtitle")}
              centered
              showAccent
              reveal={false}
            />
          </ScrollReveal>

          <div className="contact-page__main">
            <ScrollReveal className="contact-page__panel contact-page__panel--form">
              <div className="contact-page__panel-head">
                <h2 className="contact-page__panel-title">{t("contact.sendMessage")}</h2>
                <p className="contact-page__panel-subtitle">{t("contact.formSubtitle")}</p>
              </div>
              <ContactForm />
            </ScrollReveal>

            <ScrollReveal className="contact-page__panel contact-page__panel--map">
              <ContactMap />
            </ScrollReveal>
          </div>

          <ScrollReveal className="contact-page__whatsapp">
            <a
              href={whatsappHref}
              target="_blank"
              rel="noopener noreferrer"
              className="contact-page__whatsapp-btn"
            >
              <FaWhatsapp aria-hidden="true" />
              <span>{t("Contact Us on WhatsApp")}</span>
            </a>
          </ScrollReveal>
        </div>
      </section>
    </PageShell>
  );
}

export default Contact;
